module.exports = __webpack_public_path__ + "img/767.bc22227f.jpg";